"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var initialState = (0, _immutable.Map)({
  registered: 0,
  unregistered: 0
});

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _actions.FetchListRegistrationsActionTypes.SUCCESS, function (state, action) {
  var _action$payload$data = action.payload.data,
      registered = _action$payload$data.registered,
      unregistered = _action$payload$data.unregistered;
  return state.merge({
    registered: registered,
    unregistered: unregistered
  });
}), initialState);

exports.default = _default;
module.exports = exports.default;